import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import StatusIcon from "../../StatusIcon";
import Tooltip from "../../Tooltip";

export default class OrderHistoryItem extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  placeReorder = (e, order) => {
    e.preventDefault();
    e.stopPropagation();

    this.context.router.history.push({
      pathname: "/collection-orders/new",
      state: { copy: order },
    });
  };

  render() {
    const { order } = this.props;
    const date_format = "ll";
    const orderLines = order.orderLines || [];
    const rentalLines = orderLines.filter(
      (line) => line?.issueType === "Rental",
    );
    const effectiveLines = rentalLines.length > 0 ? rentalLines : orderLines;
    const hasMultipleLines = effectiveLines.length > 1;
    const firstLine = effectiveLines[0];
    const displayContainerType = firstLine?.itemId || "-";
    const displayQuantity = firstLine?.quantity ?? "-";

    return (
      <div
        className={`collection-order-history-item`}
        style={{
          backgroundColor: "white",
        }}
        onClick={() =>
          this.props.showModal(
            order,
            this.props.reorder,
            this.props.orders,
            this.props.index,
          )
        }>
        <div className="order-history-header header-style">
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <div className="header-style">
              <StatusIcon order={order} />
              <div className="header-item row-col-status">
                <div className="header-label lg:tw-hidden">Status</div>

                <div className="row-value">
                  <div className="tw-flex">
                    <span className="lg:tw-ml-2 tw-text-[14px] sm:tw-text-base">
                      {order.statusDesc}
                    </span>
                  </div>
                </div>
              </div>

              <div className="header-item row-col-date">
                <div className="header-label lg:tw-hidden">
                  Req Pick Up Date
                </div>
                <div className="row-value">
                  {moment(order.requestedDeliveryDate).isValid()
                    ? moment(order.requestedDeliveryDate).format(date_format)
                    : ""}
                </div>
              </div>

              <div className="header-item row-col-ship-from">
                <div className="header-label lg:tw-hidden">Ship From</div>
                <div className="row-value">{order.shipFromLocationName}</div>
              </div>

              <div className="header-item row-col-bol">
                <div className="header-label lg:tw-hidden">BOL #</div>
                <div className="row-value">{order.orderNumber}</div>
              </div>

              {/*
              <div className="header-item">
                <div className="header-label lg:tw-hidden">Trailer</div>
                <div className="row-value">{order.trailerNumber}</div>
              </div>
              */}

              <div className="header-item row-col-carrier">
                <div className="header-label lg:tw-hidden">Carrier Name</div>
                <div className="row-value tw-overflow-x-hidden">
                  {order.carrierName ? order.carrierName : "N/A"}
                </div>
              </div>

              <div className="header-item row-col-trailer">
                <div className="header-label lg:tw-hidden">Trailer Number#</div>
                <div className="row-value tw-overflow-x-hidden">
                  {order.trailerNumber ? order.trailerNumber : "N/A"}
                </div>
              </div>

              {/* <div className="header-item">
                <div className="header-label lg:tw-hidden">BOL NO.</div>
                <div className="row-value">{order.billOfLading}</div>
              </div> */}

              <div className="header-item row-col-rpc">
                <div className="header-label lg:tw-hidden">RPC Size</div>
                {hasMultipleLines ? (
                  <Tooltip
                    content={
                      <div className="tw-p-2 tw-min-w-[140px]">
                        <table className="tw-w-full tw-text-left tw-border-collapse">
                          <thead>
                            <tr>
                              <th className="tw-pl-0 tw-pr-3 tw-pb-1 tw-font-semibold tw-border-b tw-border-black tw-text-left">
                                RPC Size
                              </th>
                              <th className="tw-pl-2 tw-pb-1 tw-font-semibold tw-border-b tw-border-black">
                                Qty
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {effectiveLines.map((line, idx) => (
                              <tr key={idx}>
                                <td
                                  className="tw-pr-3 tw-py-0.5 tw-text-left"
                                  style={{ paddingLeft: 0 }}>
                                  {line?.itemId ?? "—"}
                                </td>
                                <td className="tw-pl-2 tw-py-0.5 tw-text-left">
                                  {line?.quantity ?? "—"}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    }
                    config={{
                      trigger: "mouseenter",
                      placement: "top",
                      theme: "custom",
                    }}>
                    <div className="row-value">
                      {displayContainerType}
                      <span
                        className="tw-text-gray-500"
                        title="Hover to view all">
                        … +{effectiveLines.length - 1}
                      </span>
                    </div>
                  </Tooltip>
                ) : (
                  <div className="row-value">{displayContainerType}</div>
                )}
              </div>

              <div className="header-item row-col-qty">
                <div className="header-label lg:tw-hidden">Quantity</div>
                <div className="row-value">{displayQuantity}</div>
              </div>

              <div className="header-item row-col-added-by">
                <div className="header-label lg:tw-hidden">Added By</div>
                <div className="row-value">{order.addedBy}</div>
              </div>

              {/* <div className="header-item">
                <div className="header-label lg:tw-hidden">Status</div>

                <div className="row-value">
                  <div className="tw-flex">
                    <StatusIcon order={order} />{" "}
                    <span className="tw-ml-2">{order.statusDesc}</span>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className="order-history-details"></div>
      </div>
    );
  }
}

const { object, bool } = PropTypes;

OrderHistoryItem.propTypes = {
  order: object.isRequired,
  expanded: bool,
  reorder: bool,
};
